import React, { createContext, useContext } from 'react';

const GameContext = createContext();

export const GameProvider = ({ user, game, socket, room, children }) => {
  return (
    <GameContext.Provider value={{ user, game, socket, room }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGameContext = () => {
  return useContext(GameContext);
};